import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { IconDefinition } from '@fortawesome/pro-regular-svg-icons';
import { faCaretDown } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Dispatch, SetStateAction } from 'react';
import { useState } from 'react';

type Props = {
	iconElements: IconDefinition[];
	selectedIcon?: IconDefinition;
	setSelectedCategoryicon: (icon: IconDefinition) => void;
	setIsLoading: Dispatch<SetStateAction<boolean>>;
};

const IconCardDropdown = React.memo(
	(props: Props) => {
		const [isOpen, setIsOpen] = useState(false);

		const toggleDropdown = () => {
			setIsOpen(!isOpen);

			setTimeout(() => {
				props.setIsLoading(false);
			}, 300);
		};

		const closeExpandedDropdown = () => {
			setIsOpen(false);
		};

		return (
			<div className="c-dropdown">
				<button
					className="c-dropdown-toggle"
					onClick={toggleDropdown}
				>
					<label className="pr-5">
						{props.selectedIcon ? (
							<FontAwesomeIcon icon={props.selectedIcon as IconProp} />
						) : (
							'-Select an Icon-'
						)}
					</label>
					<FontAwesomeIcon
						icon={faCaretDown}
						style={{ cursor: 'pointer' }}
					/>
				</button>
				{isOpen && (
					<ul className="c-dropdown-menu icon-grid">
						{props.iconElements.map((item, index) => (
							<li
								key={index}
								className="c-dropdown-item"
								onClick={() => {
									props.setSelectedCategoryicon(item);
									closeExpandedDropdown();
								}}
							>
								<FontAwesomeIcon
									icon={item as IconProp}
									size="2x"
								/>
							</li>
						))}
					</ul>
				)}
			</div>
		);
	},
	(prevProps, nextProps) => {
		// Custom comparison function to prevent re-renders
		// Only re-render if iconElements or selectedIcon changes
		return (
			prevProps.iconElements === nextProps.iconElements &&
			prevProps.selectedIcon === nextProps.selectedIcon
		);
	}
);

export default IconCardDropdown;
